import React from 'react';
import { Icon } from '@iconify/react';

interface ErrorBlockProps {
  message: string;
  className?: string;
}

const ErrorBlock: React.FC<ErrorBlockProps> = ({ message, className = '' }) => {
  return (
    <div
      className={`w-full bg-auth-error-bg border-2 border-auth-error-border rounded-3 py-3 px-4 shadow-sm  ${className}`}
    >
      <div className="flex items-center gap-4">
        <div className="size-10 bg-auth-error-bg border border-auth-error-border rounded-[1.875rem] flex items-center justify-center flex-shrink-0">
          <Icon
            icon="mingcute:information-fill"
            width="19"
            height="19"
            className="text-auth-error-text"
          />
        </div>
        <p className="text-auth-error-text text-sm font-medium leading-5">{message}</p>
      </div>
    </div>
  );
};

export default ErrorBlock;
